import React from "react";
import QuickActionPopup, { QuickActionPopupProps } from "../../../quick-action-popup/QuickActionPopup";
import { VerticalFlex } from "@vahak/core-ui/dist/layout/Flex";
import SearchIcon from "@vahak/core/dist/icons/searchWhite.svg";
import IconWrapper from "@vahak/core-ui/dist/components/IconWrapper";
import Typography from "@vahak/core-ui/dist/components/Typography";
import useMediaQuery from "@vahak/core-ui/dist/hooks/useMediaQuery";
import AppImg from "../../../utils/AppImg";

interface LoadNotAvailablePopupProps extends QuickActionPopupProps {
    onSubmit: () => void;
}

const LoadNotAvailablePopup = (props: LoadNotAvailablePopupProps) => {
    const isMobileScreen = useMediaQuery({ queryType: "mobile" });
    const { isOpen, onSubmit, onToggle } = props;
    return (
        <QuickActionPopup
            {...{ isOpen, onToggle }}
            titleText="Load no longer available"
            description={
                <VerticalFlex alignItems="center" justifyContent="center">
                    <VerticalFlex gap={8} style={isMobileScreen ? undefined : { maxWidth: 400 }} alignItems="center">
                        <div>
                            <AppImg src={"out-of-stock.png"} width={120} height={120} />
                        </div>
                        <Typography weight="semibold" size="md" align="center">
                            Looks like this load has been booked!
                        </Typography>
                        <Typography weight="medium" align="center">
                            Don't worry! You can still find similar loads from the same location
                        </Typography>
                    </VerticalFlex>
                </VerticalFlex>
            }
            ctaAction={onSubmit}
            ctaText={
                <IconWrapper gap={8}>
                    <SearchIcon />
                    Find similar loads
                </IconWrapper>
            }
            ctaProps={{
                isRounded: true,
                blockBtn: true
            }}
            modalSize="compact"
        />
    );
};

export default LoadNotAvailablePopup;
